import { render, staticRenderFns } from "./MenuMapType.vue?vue&type=template&id=2ef80e9a"
import script from "./MenuMapType.vue?vue&type=script&lang=js"
export * from "./MenuMapType.vue?vue&type=script&lang=js"
import style0 from "./MenuMapType.vue?vue&type=style&index=0&id=2ef80e9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports